/* RareKitty journey timeline — scroll-linked rail fill.

   The fill height is written every animation frame so it tracks the scrollbar
   exactly. A step turns active the moment the fill passes that step's dot, so
   the heading bar lighting up is visually caused by the line reaching it.

   NOTE the visibilitychange handler: requestAnimationFrame does not fire in a
   hidden tab. Without resetting the pending-frame guard, a scroll that starts
   just before the user switches tabs latches the guard on forever and the fill
   never updates again after they come back. */
(function () {
  function init(root) {
    if (!root || root.dataset.rkTlReady === '1') return;
    root.dataset.rkTlReady = '1';

    var rail  = root.querySelector('[data-rk-rail]');
    var fill  = root.querySelector('[data-rk-tlfill]');
    var steps = [].slice.call(root.querySelectorAll('[data-rk-step]'));
    if (!rail || !fill || !steps.length) return;

    var dots = steps.map(function (s) { return s.querySelector('[data-rk-dot]'); });
    var anchorPct = parseFloat(root.dataset.rkAnchor) || 50;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      fill.style.height = '100%';
      steps.forEach(function (s) { s.dataset.active = 'true'; });
      return;
    }

    var rafId = 0;

    function frame() {
      rafId = 0;

      var rr = rail.getBoundingClientRect();
      if (rr.height <= 0) return;

      var anchor = window.innerHeight * (anchorPct / 100);
      var h = anchor - rr.top;
      if (h < 0) h = 0;
      if (h > rr.height) h = rr.height;

      fill.style.height = h + 'px';
      // Gradient spans the whole rail so each step keeps its own colour band
      // as the fill grows past it.
      fill.style.backgroundSize = '100% ' + rr.height + 'px';

      for (var i = 0; i < steps.length; i++) {
        var d = dots[i].getBoundingClientRect();
        var dotCentre = (d.top + d.height / 2) - rr.top;
        steps[i].dataset.active = h >= dotCentre - 1 ? 'true' : 'false';
      }
    }

    function schedule() {
      if (rafId) return;
      rafId = requestAnimationFrame(frame);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', frame);

    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'visible') return;
      if (rafId) { cancelAnimationFrame(rafId); rafId = 0; }
      frame();
    });

    frame();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-rk-tlroot]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
